import Swiper from 'swiper';
import { Navigation, EffectFade, Pagination } from 'swiper/modules';

class ImageSlider {
  constructor(imageSlider) {
    Swiper.use([Navigation, EffectFade, Pagination]);

    let sliderContainer = imageSlider.parentElement.parentElement;
    let prevButton = sliderContainer.querySelector('.swiper-button-prev');
    let nextButton = sliderContainer.querySelector('.swiper-button-next');
    let paginationElement = sliderContainer.querySelector('.swiper-pagination');
    let currentSlideNumber = sliderContainer.querySelector('.js-current-slide');
    let slideCountNumber = sliderContainer.querySelector('.js-slide-count');

    var cardSwiper = new Swiper(imageSlider, {
      slidesPerView: 1,
      effect: 'fade',
      pagination: {
        el: paginationElement,
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      fadeEffect: {
        crossFade: true
      },
      grabCursor: true,
      loop: true,
      autoHeight: true,
      init: false
    })

    // cardSwiper.on('slideChange', () => {
    //   currentSlideNumber.innerHTML = `${cardSwiper.realIndex + 1}`
    //   slideCountNumber.innerHTML = `${cardSwiper.slides.length - 2}` // minus 2 because of looping
    // });

    // cardSwiper.on('init', () => {
    //   slideCountNumber.innerHTML = `${cardSwiper.slides.length - 2}`
    // });

    cardSwiper.init();
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const imageSliders = document.querySelectorAll('.js-image-slider');
  if (imageSliders.length > 0) {
    const imageSlidersArray = [...imageSliders];

    imageSlidersArray.forEach((imageSlider) => {
      new ImageSlider(imageSlider)
    });
  }
});
